import { Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormArray } from '@angular/forms';

@Injectable({ providedIn: "root" })
export class FormTouchUtil {

  /**
   * Vynutí revalidaci všech prvků formuláře a označí je jako "touched", čímž dojde k zobrazení validačních chyb
   * Inspirace: https://loiane.com/2017/08/angular-reactive-forms-trigger-validation-on-submit/
   * @param formGroup
   */
  touchAllFormFields(formGroup: UntypedFormGroup | UntypedFormArray) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.updateValueAndValidity({ onlySelf: true, emitEvent: true });
        control.markAsTouched({ onlySelf: true });
      }
      else if (control instanceof UntypedFormGroup || control instanceof UntypedFormArray) {
        this.touchAllFormFields(control);
        control.updateValueAndValidity({ onlySelf: true, emitEvent: true });
        control.markAllAsTouched();
      }
    });
  }
}
